import React from "react";
import { StyledBubbleItem } from "./style";

type AssistantBubbleProps = {
  content: string;
  status?: "success" | "error";
};

const AssistantBubble = ({ content, status }: AssistantBubbleProps) => {
  return (
    <StyledBubbleItem className={`assistant-bubble ${status}`}>
      <div
        className="assistant-bubble-content"
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </StyledBubbleItem>
  );
};

export default AssistantBubble;
